import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://uvizcutelqsanjvfseuv.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV2aXpjdXRlbHFzYW5qdmZzZXV2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAxMjEzNjEsImV4cCI6MjA2NTY5NzM2MX0.D1csRnxf34V3xghhLKm2AwYTvPOeFTfkti_HPfiH0gE";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
